import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuth, getIdToken } from "firebase/auth";

let cachedToken: string | null = null;
let cachedExpirationTime: Date | null = null;

export const apiSlice = createApi({
  // All of our requests will have URLs starting with '/api'
  reducerPath: "api",
  // Keep cache for 15 minutes after last reference is removed
  keepUnusedDataFor: 60 * 15,
  baseQuery: fetchBaseQuery({
    // Use apiUrl from index.html, or localhost if not supplied
    // We can inject apiUrl into index.html when serving index.html.
    baseUrl: ((window as any).apiUrl || "http://localhost:8080") + "/api",
    method: "POST",
    prepareHeaders: async (headers) => {
      const user = getAuth().currentUser;
      if (user == null) {
        return headers;
      }
      const now = new Date();
      const oneMinuteAgo = new Date(now.getTime() - 60000); // 60000 milliseconds = 1 minute
      if (
        cachedToken == null ||
        cachedExpirationTime == null ||
        oneMinuteAgo > cachedExpirationTime
      ) {
        cachedToken = await getIdToken(user);
        const decodedToken = await user.getIdTokenResult();
        cachedExpirationTime = new Date(decodedToken.expirationTime);
      }
      // If we have a token set in state, let's assume that we should be passing it.
      if (cachedToken) {
        headers.set("authorization", `Bearer ${cachedToken}`);
      }

      return headers;
    },
  }),
  tagTypes: ["Connect", "Guests", "Guest"],
  endpoints: () => ({}),
});
